// src/lib/scList.js — utilitários de lista fiéis ao DataTable oficial (dashboard-01).
// Paginação: esquerda "X–Y de Z linha(s)"; direita "Linhas por página" (Select sm 80)
// + "Página X de Y" (14 medium) + 4 botões outline 32×32 («‹›»).

export function paginate(arr, page, size) {
  const total = arr.length;
  const pages = Math.max(1, Math.ceil(total / size));
  const p = Math.min(Math.max(1, Number(page) || 1), pages);
  const start = (p - 1) * size;
  return { slice: arr.slice(start, start + size), page: p, pages, total, from: total ? start + 1 : 0, to: Math.min(start + size, total) };
}

// goFn/sizeFn: nomes de funções globais (window.*) — módulos vanilla usam onclick inline.
export function scPagerHTML({ page, pages, total, from, to, goFn, sizeFn, size }) {
  const btn = (lbl, target, dis) => `<button class="sc-btn outline icon sm" ${dis ? 'disabled' : ''} onclick="${goFn}(${target})">${lbl}</button>`;
  return `<div class="sc-pager">
    <span>${total ? `${from}–${to} de ${total} linha(s)` : '0 linha(s)'}</span>
    <div class="rt">
      <label>Linhas por página
        <select class="sc-input" onchange="${sizeFn}(this.value)">${[10, 20, 30, 50].map((n) => `<option value="${n}" ${n === size ? 'selected' : ''}>${n}</option>`).join('')}</select>
      </label>
      <span class="pg">Página ${page} de ${pages}</span>
      <div class="btns">
        ${btn('«', 1, page <= 1)}${btn('‹', page - 1, page <= 1)}${btn('›', page + 1, page >= pages)}${btn('»', pages, page >= pages)}
      </div>
    </div>
  </div>`;
}
